import {StringMap} from "ra-core/src/i18n/TranslationMessages";

const frMessages: StringMap = {
};

export default frMessages;
